export class ListaUsuario{
  itens: ItemUsuario[];
}

export class ItemUsuario{
  id: number;
  nome: string;
  tipo: number;
  ativo: boolean;
  dataCadastro: Date;
  email: string;
}
